const languages = [
  { language: "Albanian", Alpha2Code: "AL" },
  { language: "Amharic", Alpha2Code: "ET" },
  { language: "Arabic", Alpha2Code: "SA" },
  { language: "Armenian", Alpha2Code: "AM" },
  { language: "Azerbaijani", Alpha2Code: "AZ" },
  { language: "Belarusian", Alpha2Code: "BY" },
  { language: "Bengali", Alpha2Code: "BD" },
  { language: "Bislama", Alpha2Code: "VU" },
  { language: "Bosnian", Alpha2Code: "BA" },
  { language: "Bulgarian", Alpha2Code: "BG" },
  { language: "Burmese", Alpha2Code: "MM" },
  { language: "Catalan", Alpha2Code: "ES" },
  { language: "Chichewa", Alpha2Code: "MW" },
  { language: "Chinese", Alpha2Code: "CN" },
  { language: "Comorian", Alpha2Code: "KM" },
  { language: "Croatian", Alpha2Code: "HR" },
  { language: "Czech", Alpha2Code: "CZ" },
  { language: "Danish", Alpha2Code: "DK" },
  { language: "Dhivehi", Alpha2Code: "MV" },
  { language: "Dutch", Alpha2Code: "NL" },
  { language: "Dzongkha", Alpha2Code: "BT" },
  { language: "English", Alpha2Code: "GB" },
  { language: "Estonian", Alpha2Code: "EE" },
  { language: "Faroese", Alpha2Code: "FO" },
  { language: "Filipino", Alpha2Code: "PH" },
  { language: "Finnish", Alpha2Code: "FI" },
  { language: "French", Alpha2Code: "FR" },
  { language: "Georgian", Alpha2Code: "GE" },
  { language: "German", Alpha2Code: "DE" },
  { language: "Greek", Alpha2Code: "GR" },
  { language: "Greenlandic", Alpha2Code: "GL" },
  { language: "Hebrew", Alpha2Code: "IL" },
  { language: "Hindi", Alpha2Code: "IN" },
  { language: "Hungarian", Alpha2Code: "HU" },
  { language: "Icelandic", Alpha2Code: "IS" },
  { language: "Indonesian", Alpha2Code: "ID" },
  { language: "Irish", Alpha2Code: "IE" },
  { language: "Italian", Alpha2Code: "IT" },
  { language: "Japanese", Alpha2Code: "JP" },
  { language: "Kazakh", Alpha2Code: "KZ" },
  { language: "Khmer", Alpha2Code: "KH" },
  { language: "Kinyarwanda", Alpha2Code: "RW" },
  { language: "Kirundi", Alpha2Code: "BI" },
  { language: "Korean", Alpha2Code: "KR" },
  { language: "Kyrgyz", Alpha2Code: "KG" },
  { language: "Lao", Alpha2Code: "LA" },
  { language: "Latvian", Alpha2Code: "LV" },
  { language: "Libyan Arabic", Alpha2Code: "LY" },
  { language: "Lithuanian", Alpha2Code: "LT" },
  { language: "Luxembourgish", Alpha2Code: "LU" },
  { language: "Macedonian", Alpha2Code: "MK" },
  { language: "Malagasy", Alpha2Code: "MG" },
  { language: "Malay", Alpha2Code: "MY" },
  { language: "Maltese", Alpha2Code: "MT" },
  { language: "Mandarin", Alpha2Code: "CN" },
  { language: "Marshallese", Alpha2Code: "MH" },
  { language: "Moldovan", Alpha2Code: "MD" },
  { language: "Mongolian", Alpha2Code: "MN" },
  { language: "Montenegrin", Alpha2Code: "ME" },
  { language: "Nauruan", Alpha2Code: "NR" },
  { language: "Nepali", Alpha2Code: "NP" },
  { language: "Niuean", Alpha2Code: "NU" },
  { language: "Norwegian", Alpha2Code: "NO" },
  { language: "Palauan", Alpha2Code: "PW" },
  { language: "Pashto", Alpha2Code: "AF" },
  { language: "Persian", Alpha2Code: "IR" },
  { language: "Polish", Alpha2Code: "PL" },
  { language: "Portuguese", Alpha2Code: "PT" },
  { language: "Romanian", Alpha2Code: "RO" },
  { language: "Russian", Alpha2Code: "RU" },
  { language: "Samoan", Alpha2Code: "WS" },
  { language: "Serbian", Alpha2Code: "RS" },
  { language: "Sesotho", Alpha2Code: "LS" },
  { language: "Seychellois Creole", Alpha2Code: "SC" },
  { language: "Sinhala", Alpha2Code: "LK" },
  { language: "Slovak", Alpha2Code: "SK" },
  { language: "Slovenian", Alpha2Code: "SI" },
  { language: "Somali", Alpha2Code: "SO" },
  { language: "Spanish", Alpha2Code: "ES" },
  { language: "Swahili", Alpha2Code: "TZ" },
  { language: "Swedish", Alpha2Code: "SE" },
  { language: "Tajik", Alpha2Code: "TJ" },
  { language: "Tetum", Alpha2Code: "TL" },
  { language: "Thai", Alpha2Code: "TH" },
  { language: "Tigrinya", Alpha2Code: "ER" },
  { language: "Tok Pisin", Alpha2Code: "PG" },
  { language: "Tokelauan", Alpha2Code: "TK" },
  { language: "Tongan", Alpha2Code: "TO" },
  { language: "Turkish", Alpha2Code: "TR" },
  { language: "Turkmen", Alpha2Code: "TM" },
  { language: "Tuvaluan", Alpha2Code: "TV" },
  { language: "Ukrainian", Alpha2Code: "UA" },
  { language: "Urdu", Alpha2Code: "PK" },
  { language: "Uzbek", Alpha2Code: "UZ" },
  { language: "Vietnamese", Alpha2Code: "VN" },
  { language: "Zulu", Alpha2Code: "ZA" },
];

export default languages;
